var _g, _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1617_1550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.87988 11.49L14.7599 7.75L24.6399 11.49L14.7599 15.6L4.87988 11.49Z",
    fill: "#C8D1D9",
    stroke: "#3F4950",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87988 11.49L14.7599 15.6L14.7399 28.54L4.87988 24V11.49Z",
    stroke: "#3F4950",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.66 11.49L14.77 15.6L14.8 28.54L24.66 24V11.49Z",
    stroke: "#3F4950",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.88 11.49L0.75 16.64L10.83 21.19L14.77 15.6L4.88 11.49Z",
    fill: "white",
    stroke: "#3F4950",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.62 11.49L28.75 16.64L18.67 21.19L14.73 15.6L24.62 11.49Z",
    fill: "white",
    stroke: "#3F4950",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7598 7.75V16.55",
    stroke: "#3F4950",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.75,
    y: 0.75,
    width: 16.5,
    height: 16.5,
    rx: 8.25,
    fill: "#3AB24A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.75,
    y: 0.75,
    width: 16.5,
    height: 16.5,
    rx: 8.25,
    stroke: "#3F4950",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 8.72727L25.3333 12L29.5 6",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1617_1550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.5,
    height: 22.29,
    fill: "white",
    transform: "translate(0 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.85e64c85d85a375fc19582669b9bcf13.svg";
export { ForwardRef as ReactComponent };